import {CustomError} from "../../shared/errors/CustomErrors";
import {Option} from "../../shared/utilities/OptionT";
import {APIDao, Requester} from "../APIRequester";
import {OrderProduct} from "../../shared/entities/OrderProduct/OrderProduct";
import {ORDER_API_PREFIX, ORDER_PRODUCTS_API_PREFIX} from "../../common/constants";

/**
 * ProductRepository.
 *
 * Responsible for fetching data from backend
 * by callind APIDao and handling various data
 * coming from API
 *
 * Data is passed to ClientService in a form of
 * an @type Option<T> type, where @param{Some: T} is either
 * a valid data, expected from the server,
 * or, in case of error, a default safe value,
 * for an object of array (kinda like default
 * values for types in Go),and @param{None: CustomError}
 * is either an error or undefined
 */
export class OrderProductRepository {
    private dao: Requester

    constructor(dao: Requester) {
        this.dao = dao
    }

    public async getOrderProducts(id: number): Promise<Option<Array<OrderProduct>>> {
        return await this.dao.getRequest<Array<OrderProduct>>(`${ORDER_PRODUCTS_API_PREFIX}/${id}`, {}).then(res => {
            const result: Option<Array<OrderProduct>> = {
                Some: res.data,
            }
            return result
        }).catch((err: CustomError) => {
            const result: Option<Array<OrderProduct>> = {
                Some: [],
                None: err
            }
            return result
        })
    }

    public async getAllProductsFromDealerOrders(id: number, params: any): Promise<Option<Array<any>>> {
        return await this.dao.getRequest<Array<OrderProduct>>(`${ORDER_PRODUCTS_API_PREFIX}/all/${id}`, {params}).then(res => {
            const result: Option<Array<OrderProduct>> = {
                Some: res.data,
            }
            return result
        }).catch((err: CustomError) => {
            const result: Option<Array<OrderProduct>> = {
                Some: [],
                None: err
            }
            return result
        })
    }

    public async addedProductVendor(data: any): Promise<Option<number>> {
        return await this.dao.postRequest<number>(`${ORDER_PRODUCTS_API_PREFIX}/added-product-vendor`, {data}).then(res => {
            const result: Option<number> = {
                Some: res?.data,
            }
            return result
        }).catch((err: CustomError) => {
            const result: Option<number> = {
                Some: 0,
                None: err
            }
            return result
        })
    }
}

export const OrderProductRepositoryInstance = new OrderProductRepository(APIDao)
